// Generated by ReScript, PLEASE EDIT WITH CARE


var nbaAgreementId = "9a67a491-fffa-4a14-ba35-898c23040a4b";

export {
  nbaAgreementId ,
}
/* No side effect */
